import ApplicationOverviewCard from './ApplicationOverviewCard'
import JobOfferCard from './JobOfferCard'
import InterviewScheduleCard from './InterviewScheduleCard'
import PreOnBoardingCard from './PreOnBoardingCard'

const ActiveApplicationRenderer = ({
  application,
  holidayDates,
  lang,
  selectedDate,
  selectedSlotId,
  isSubmitting,
  isRescheduling,
  userToken,
  onDateChange,
  onSlotChange,
  onConfirm,
  onRefresh,
  onReschedule,
}) => {
  const currentJobOfferStatus = String(application?.jobOffer?.status || '').trim()
  const isPendingJobOfferApplication =
    application?.displayStatus === 'Job Offer' &&
    application?.isOffer !== true &&
    application?.isOffer !== false
  const isPreOnBoardingApplication =
    currentJobOfferStatus === 'PreOnBoardingDraft' ||
    currentJobOfferStatus === 'PreOnBoardingSubmitted' ||
    currentJobOfferStatus === 'PreOnBoardingExpired'
  const shouldRenderJobOfferCard =
    isPendingJobOfferApplication &&
    application?.jobOffer?.isAvailable === true &&
    !isPreOnBoardingApplication

  if (isPendingJobOfferApplication && isPreOnBoardingApplication) {
    return (
      <PreOnBoardingCard
        application={application}
        lang={lang}
        userToken={userToken}
        onRefresh={onRefresh}
      />
    )
  }

  if (shouldRenderJobOfferCard) {
    return (
      <JobOfferCard
        application={application}
        lang={lang}
        userToken={userToken}
        onRefresh={onRefresh}
      />
    )
  }

  if (application?.kind === 'overview') {
    return (
      <ApplicationOverviewCard
        job={application}
        lang={lang}
        allowActions
        onRefresh={onRefresh}
      />
    )
  }

  return (
    <InterviewScheduleCard
      application={application}
      holidayDates={holidayDates}
      lang={lang}
      selectedDate={selectedDate}
      selectedSlotId={selectedSlotId}
      isSubmitting={isSubmitting}
      isRescheduling={isRescheduling}
      onDateChange={onDateChange}
      onSlotChange={onSlotChange}
      onConfirm={onConfirm}
      onReschedule={onReschedule}
    />
  )
}

export default ActiveApplicationRenderer
